import { useDispatch, useSelector, connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { confirmAlert } from "react-confirm-alert";

import { positionsActions, devicesActions } from "./store";
import { useEffectAsync } from "./reactHelper";
import Conf from "../conf";
import styles from "../styles/management.module.css";
import React from "react";

const RetryInterval = 10 * 1000;
let interval;
const Socket = () => {
    const Dispatch = useDispatch();
    const user = useSelector((state) => state.session.user);
    const devices = useSelector((state) => state.devices.items);

    const checkSubscription = (devices) => {
        if (user && !user.administrator) {
            const now = new Date();
            const expiredDevices = devices.filter((device) => {
                if (device.attributes && device.attributes.subscriptionEndDate) {
                    const endDate = new Date(device.attributes.subscriptionEndDate);
                    return endDate < now;
                }
                return false;
            });

            if (expiredDevices.length > 0 && !window.subscriptionAlertShown) {
                window.subscriptionAlertShown = true;
                const deviceNames = expiredDevices.map((d) => d.name).join("، ");

                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <div className={styles.custom_ui}>
                                <h1>
                                    اشتراک {expiredDevices.length === 1 ? "دستگاه " : "دستگاه های "} {deviceNames} به پایان رسیده است.
                                    <br />
                                    لطفا برای تمدید اشتراک با شماره ۰۹۰۱۹۰۹۹۹۸۸ تماس بگیرید.
                                </h1>
                                <button onClick={onClose}>متوجه شدم</button>
                            </div>
                        );}
                    })
            }

            return devices.filter((device) => {
                if (device.attributes && device.attributes.subscriptionEndDate) {
                    const endDate = new Date(device.attributes.subscriptionEndDate);
                    return endDate >= now;
                }
                return true;
            });
        }
        return devices;
    };

    const filterPositions = (positions) => {
        if (user && !user.administrator) {
            const deviceIds = new Set(devices.map((d) => d.id));
            return positions.filter((p) => deviceIds.has(p.deviceId));
        }
        return positions;
    };

    const ConnectSocket = (Try = 0) => {
        if (Try > 1) {
            NotificationManager.error("خطا در ارتباط با سرور", "لطفا وضعیت اینترنت خود را برسی کنید", RetryInterval);
        }
        const Connection = new WebSocket("wss://api.radyabe.ir/api/socket");

        Connection.onopen = () => {
            Try = 0;
        };

        Connection.onmessage = (event) => {
            const data = JSON.parse(event.data);

            if (data.devices) {
                Dispatch(devicesActions.update(checkSubscription(data.devices)));
            } else if (data.positions) {
                Dispatch(positionsActions.update(filterPositions(data.positions)));
            }
        };

        Connection.onclose = () => {
            if (interval) clearTimeout(interval);
            interval = setTimeout(() => ConnectSocket(++Try), RetryInterval);
        };

        Connection.onerror = (_Error) => {
            if (interval) clearTimeout(interval);
            interval = setTimeout(() => {
                ConnectSocket(++Try);
            }, RetryInterval);
        };
    };

    useEffectAsync(async () => {
        let response = await fetch(`${Conf.server_address}/devices`, { method: "GET", credentials: "include" });
        if (response.ok) {
            const validDevices = checkSubscription(await response.json());
            Dispatch(devicesActions.refresh(validDevices));

            let positionsResponse = await fetch(`${Conf.server_address}/positions`, {
                method: "GET",
                credentials: "include",
            });
            if (positionsResponse.ok) {
                let positions = await positionsResponse.json();
                if (user && !user.administrator) {
                    const deviceIds = new Set(validDevices.map((d) => d.id));
                    positions = positions.filter((p) => deviceIds.has(p.deviceId));
                }
                Dispatch(positionsActions.update(positions));
            }

            ConnectSocket();
        }

        return () => {
            if (interval) clearTimeout(interval);
        };
    }, []);

    return null;
};

export default connect()(Socket);
